/* @flow */

import { connect } from 'react-redux';
import { get, toString } from 'lodash/fp';

import t from 'app/utils/translate';
import SocialShareButtons from './SocialShareButtons';
import shareMessageSelector from '../../selectors/shareMessageSelector';
import { shareChallenge } from '../../actions/challengeActions';

function mapStateToProps(state) {
  const shareUrl = `${get('settings.siteUrl', state)}${window.location.pathname}`;
  const messageTitle = shareMessageSelector(state);
  const competitionName = toString(state.challenge.competitionName).replace(/\s/g, '');
  const twitterHashtags = state.settings.social.twitterHashtags.map(hashTag =>
    hashTag.replace('__SPORT_NAME__', competitionName)
  );
  return {
    emailErrors: state.challenge.shareChallengeErrorMessages,
    emailTitle: 'Invite to Challenge',
    facebookTitle: messageTitle,
    facebookUrl: shareUrl,
    isSharing: state.challenge.sharingChallenge,
    challengeUrl: get('challenge.id', state)
      ? `${get('settings.siteUrl', state)}/fantasy/${t('challenge').toLowerCase()}/${get(
          'challenge.id',
          state
        )}`
      : undefined,
    twitterHashtags,
    twitterTitle: messageTitle,
    twitterUrl: shareUrl,
    twitterVia: state.settings.social.twitterVia
  };
}

const actions = {
  onEmailSubmit: shareChallenge
};

export default connect(
  mapStateToProps,
  actions
)(SocialShareButtons);
